@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantConnectionHealthDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto

object CheckVoiceAssistantMcpHealthEndpoint :
    EndPoint<CheckVoiceAssistantMcpHealthEndpoint.Request, CheckVoiceAssistantMcpHealthEndpoint.Response>() {
    class Request(val settings: VoiceAssistantSettingsDto)
    class Response(val elasticsearchMcp: VoiceAssistantConnectionHealthDto)
}
